import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Grid  } from "@material-ui/core";
import DailyHiLo from "../../components/DailyHiLo";

import {
    setLastTrade,
    FETCH_MLFORECAST_REQUEST_SECOND,
    FETCH_MLFORECAST_RESET_SECOND,
    FETCH_MLFORECAST_RESET_THIRD,
    FETCH_MLFORECAST_RESET,
} from "store/actions";

import { makeStyles, useTheme } from "@material-ui/styles";
import colors from 'assets/scss/_themes-vars.module.scss';

import {
  createChart,
  createPriceLine,
  CrosshairMode,
} from "lightweight-charts";
import CoinContext from "contexts/CoinContext";
import { useSelector, useDispatch } from "react-redux";
import I from "immutable";
import axios from "axios";
// 1. No duplicates in the CandleStick Time Series
// 2. All time values must be Ascending order (increasing)
// 3. No NULL values in OHLC for that timestamp

const useStyles = makeStyles((theme) => ({
}));

const LightweightSecondChart = ({chart_index}) => {

  const [previousCoin, setPreviousCoin] = useState("");
  const [previousTS, setPreviousTS] = useState(0);
  const [prevMacdTS, setPrevMacdTS] = useState(0);
  const [fetchTrigger, setFetchTrigger] = useState(0); // 1. The state to trigger the effect
  const [chartUpdated, setChartUpdated] = useState(false); // 1. The state to trigger the effect
  const [predict, setPredict] = useState(false); // 1. The state to trigger the effect

  const handleClick = () => {
    // 2. Update the state on button click
    setFetchTrigger(prevTrigger => prevTrigger + 1);
    console.log( 'HandleClick: ' + fetchTrigger);
    // NOT YET setChartUpdated(false);
  };


  const chartContainerRef = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk = (theme.palette.mode === 'dark') ? 'white' : colors.cornsilkDarkTakyon;
  const whiteTakyon = (theme.palette.mode === 'dark') ? colors.whiteLightTakyon : colors.whiteDarkTakyon;
  const green = (theme.palette.mode === 'dark') ? colors.successLightTakyon : colors.successMain;
  const red = (theme.palette.mode === 'dark') ? colors.errorLightTakyon : colors.errorDarkTakyon;
  const bgcolor = (theme.palette.mode === 'dark') ? '#010F17' : 'white';
  // ORIG TODO const bgcolor = theme.palette.background.paper;

  const chart = useRef();
  const series = useRef();
  const avgLine = useRef();
  const priceLine = useRef();
  const lineSeries = useRef();
  // TODO DISABLED const mlpSeries = useRef();
  // TODO DISABLED const rigSeries = useRef();
  // TODO DISABLED const knrSeries = useRef();
  // TODO DISABLED const lnrSeries = useRef();
  // TODO DISABLED const lasSeries = useRef();
  const lgbSeries = useRef();
  const third_lgbSeries = useRef();
  const fifth_lgbSeries = useRef();
  const first_lgbSeries = useRef();

  const current_interval = useSelector((state) => state.chart.ohlcIntervalSecond);

  const symbolRef = useRef(previousCoin);
  const intervalRef = useRef(current_interval);

  const resizeObserver = useRef();
  const { coin } = useContext(CoinContext);

  const ohlc_done_second = useSelector((state) => {return state.coins.ohlc_done_second;});
  // TMD console.log( "SECOND -------- OHLC_DONE_CHART_JS ----- : " + ohlc_done_second);

  if ( previousCoin !== coin)
  {
    // TMD console.log( 'Sameer Chart prev: ' + previousCoin + ', coin: ' + coin + ', chart_index: ' + chart_index);
    setPreviousCoin(coin);
    setFetchTrigger(prevTrigger => prevTrigger + 1);
    setChartUpdated(false);
  }

  useEffect(() => {
    // TMD console.log( 'NOW RESETTING CHART_UPDATED TO false FOR ohlc_done4 = false, ' + lcoin);
    setChartUpdated(false);
    setFetchTrigger(prevTrigger => prevTrigger + 1);
  }, [ohlc_done_second]);

  useEffect(() => {
      symbolRef.current = previousCoin;
  }, [previousCoin]);

  useEffect(() => {
      intervalRef.current = current_interval;
  }, [current_interval]);

  const ltp = useSelector((state) => {
    return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(symbolRef.current) && state.coins.kraken_asset_pairs.get(symbolRef.current).ltp) || 0.0);
  });

  const predict_history = useSelector((state) => (state.chart.mapPredictHistory.get(symbolRef.current + '-' + String(intervalRef.current)) || undefined));
  // TMD console.log('------------------------------------ PREDICT_HISTORY -------------------- ' + symbolRef.current + '-' + String(intervalRef.current));
  // TMD console.log(predict_history);



  let markers_positive = [];
  let markers_negative = [];

  let marker_start_ts = 0;
  let marker_start_color = 'lightgreen';
  const portfolio = useSelector((state) => {
    if (state.coins.kraken_asset_pairs) {
      let item = state.coins.kraken_asset_pairs.get(coin);
      if (item !== undefined && item.swl_positive_marker !== undefined) 
      {
        markers_positive = item.swl_positive_marker;
        marker_start_color = 'green';
      } 
      if (item !== undefined && item.swl_negative_marker !== undefined) 
      {
        markers_negative = item.swl_negative_marker;
        marker_start_color = 'red';
      }

      if ((item !== undefined) && (item.position !== undefined) && (item.position.remaining_qty !== undefined)) {
        return [
          item.position.remaining_qty.toFixed(2),
          (item.position.remaining_qty * ltp).toFixed(2),
          item.position.realized,
          item.position.unrealized,
          item.position.remaining_avg_price,
        ];
      } else {
        return [0, 0, 0, 0, 0];
      }
    } else {
      return [0, 0, 0, 0, 0];
    }
  });

    const avg_px = portfolio[4];
    let avg_ts = 0;
    let avg_df = 1000000.0;

    const lastTrade = useSelector((state) => {

        let items = [];

        if (state.takyon.mapTrades !== undefined) {
          let count = 0;
          state.takyon.mapTrades.forEach((item, i) => {
            if (item.pair === coin) {
              items.push(item);
            }
          });
        }

        items.sort(function(a, b) {
            return (b.time_ms - a.time_ms);
        });
        return items;
    });


  let lwData =  useSelector((state) => {
    let data = []; 
    Object.keys(state.chart.secondData).map((key) => {
        if ( key === coin)
        {
            const uniqObj = state.chart.secondData[key];
            let prevTS = 0;
            uniqObj.map((item, index) => {
                if ( item.time > prevTS)
                {
                    prevTS = item.time;
                    data = [...data, item];
                }
            });
        }
    });
    return data;
  });

  let mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapSecondMLForecast.get(symbolRef.current + '-' + String(intervalRef.current));
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  let third_mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapThirdMLForecast.get(symbolRef.current + '-30');
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  let fifth_mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapMLForecast.get(symbolRef.current + '-5');
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  let first_mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapFirstMLForecast.get(symbolRef.current + '-1');
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  let lwMACD =  useSelector((state) => {
    let data = []; 
    Object.keys(state.chart.secondData).map((key) => {
        if ( key === coin)
        {
            const uniqObj = state.chart.secondData[key];
            let prevTS = 0;
            uniqObj.map((item, index) => {
                if ( item.macd > 0 && item.time > prevTS)
                {
                    prevTS = item.time;
                    data = [...data, {time: item.time, value: item.macd}];
                }
            });
        }
    });
    return data;
  });

  const mlforecast_loading = useSelector((state) => state.chart.second_mlforecast_loading);
  const third_mlforecast_loading = useSelector((state) => state.chart.third_mlforecast_loading);
  const fifth_mlforecast_loading = useSelector((state) => state.chart.mlforecast_loading);
  const first_mlforecast_loading = useSelector((state) => state.chart.first_mlforecast_loading);

  useEffect(() => {
    // TMD console.log( 'USE EFFECT------ CREATE CHART');
    // init chart, do not modify here
    chart.current = createChart(chartContainerRef.current, {
      height: 500,
      layout: {
        backgroundColor: bgcolor,
        textColor: cornsilk,
      },
      grid: {
        vertLines: {
            visible: false,
            color: "#111",
        },
        horzLines: {
            visible: false,
            color: "#111",
        },
      },
      crosshair: {
        vertLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        horzLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        mode: CrosshairMode.Normal,
      },
      priceScale: {
        borderColor: "#888",
        borderVisible: false,
      },
      alignLabels: true,
      timeScale: {
        rightOffset: 10,
        barSpacing: 8,
        fixLeftEdge: false,
        lockVisibleTimeRangeOnResize: true,
        rightBarStaysOnScroll: true,
        borderVisible: false,
        borderColor: "#888",
        visible: true,
        timeVisible: true,
        secondsVisible: true,
      },
    });

    // upColor: "#4bffb5",
    // downColor: "#ff4976",
    /*
    TODO denys orig
     *
    const candleSeries = chart.current.addCandlestickSeries({
      width: '100%',
      upColor: "#000000",
      downColor: "#ff4976",
      borderUpColor: "#4bffb5",
      borderDownColor: "#ff4976",
      wickUpColor: "#4bffb5",
      wickDownColor: "#ff4976",
    });
    */

    const candleSeries = chart.current.addCandlestickSeries({
      upColor: green,
      downColor: red,
      borderUpColor: green,
      borderDownColor: red,
      wickUpColor: green,
      wickDownColor: red,
    });

    candleSeries.setData([
            {time: 1773166429, open: 9.35, high: 9.35, low: 9.35, close: 9.35}, 
            {time: 1773166436, open: 9.35, high: 9.36, low: 9.34, close: 9.34}, 
            {time: 1773166437, open: 9.35, high: 9.35, low: 9.35, close: 9.35}, 
            {time: 1773166441, open: 9.35, high: 9.35, low: 9.34, close: 9.34}, 
            {time: 1773166451, open: 9.35, high: 9.35, low: 9.33, close: 9.33}, 
            {time: 1773166453, open: 9.34, high: 9.34, low: 9.32, close: 9.33}, 
            {time: 1773166454, open: 9.33, high: 9.33, low: 9.33, close: 9.33}, 
            {time: 1773166480, open: 9.35, high: 9.36, low: 9.32, close: 9.32}, 
            {time: 1773166489, open: 9.32, high: 9.32, low: 9.31, close: 9.31}, 
            {time: 1773166491, open: 9.31, high: 9.32, low: 9.29, close: 9.3}, 
            {time: 1773166492, open: 9.3, high: 9.32, low: 9.3, close: 9.32}, 
            {time: 1773166514, open: 9.32, high: 9.37, low: 9.29, close: 9.31}, 
            {time: 1773166520, open: 9.31, high: 9.32, low: 9.28, close: 9.28}, 
            {time: 1773166521, open: 9.28, high: 9.29, low: 9.28, close: 9.29}, 
            {time: 1773166522, open: 9.29, high: 9.3, low: 9.29, close: 9.3}, 
            {time: 1773166535, open: 9.31, high: 9.32, low: 9.31, close: 9.31}, 
            {time: 1773166540, open: 9.31, high: 9.34, low: 9.31, close: 9.31}
    ]);

    avgLine.current = candleSeries.createPriceLine({
      price: "0.00",
      color: "orange",
      lineWidth: -1,
      lineStyle: 0,
      axisLabelVisible: true,
      title: "avg",
    });

    lineSeries.current = chart.current.addLineSeries({
        color: '#2962FF',
        lineWidth: 2,
    });

    /*
     * TODO DISABLED 
     *
    mlpSeries.current = chart.current.addLineSeries({
        color: 'cornsilk',
        lineWidth: 2,
        priceLineVisible: false,
    });
    rigSeries.current = chart.current.addLineSeries({
        color: 'orange',
        lineWidth: 2,
        priceLineVisible: false,
    });
    knrSeries.current = chart.current.addLineSeries({
        color: 'green',
        lineWidth: 2,
        priceLineVisible: false,
    });
    lnrSeries.current = chart.current.addLineSeries({
        color: 'lightblue',
        lineWidth: 2,
        priceLineVisible: false,
    });
    lasSeries.current = chart.current.addLineSeries({
        color: 'yellow',
        lineWidth: 2,
        priceLineVisible: false,
    });
    */
    lgbSeries.current = chart.current.addLineSeries({
        color: 'red',
        lineWidth: 2,
        priceLineVisible: false,
    });
    third_lgbSeries.current = chart.current.addLineSeries({
        color: 'orange',
        lineWidth: 2,
        priceLineVisible: false,
    });
    fifth_lgbSeries.current = chart.current.addLineSeries({
        color: 'yellow',
        lineWidth: 2,
        priceLineVisible: false,
    });
    first_lgbSeries.current = chart.current.addLineSeries({
        color: 'white',
        lineWidth: 2,
        priceLineVisible: false,
    });

    // 3. Set the data

    /****
    chart.current.subscribeClick(function(param) {
        // TMD console.log(param);

        // NO POINT CLICKED
        if ( !param.point || !param.time) {
          return;
        }

        // Let's send the 'predict' query here
        console.log( 'dispatching...FETCH_MLFORECAST_REQUEST_SECOND ' + symbolRef.current + ', time: ' + param.time);
        const postdata = { "query": {"height": 30, "type": 3, "symbol": symbolRef.current + "-" + String(intervalRef.current), "time": param.time}};
        console.log(JSON.stringify(postdata));
        dispatch( {type: FETCH_MLFORECAST_REQUEST_SECOND, payload: postdata});
        setPredict(true);
    });
    *****/
    series.current = candleSeries;
 
  }, []);

  
  useEffect(() => {
    //update chart data here
    // TMD console.log( 'USE EFFECT------ UPDATE CHART ------> ' + lwData.length + ', ohlc_done_second: ' + ohlc_done_second);
    if (series.current) {
        // Let's add one bar with LTP to this
        if ( (lwData.length > 1) && ohlc_done_second)
        {
                // TMD console.log( 'Trying to UPDATE  MLForecast PREDICTIONS ' + symbolRef.current + ', chartUpdated: ' + chartUpdated+ ', mlfload: ' + mlforecast_loading);
                if ( (mlpData !== undefined) && (!chartUpdated || (mlforecast_loading === 2)) )
                {
                        console.log( 'SECOND_SECOND_SECOND_ updating MLForecast PREDICTIONS ' + symbolRef.current);
                        console.log(mlpData.get('LGBMRegressor'));

                        lgbSeries.current.setData(mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET_SECOND, payload: {}});
                } else if ( mlpData === undefined) {
                        // TMD console.log( '1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + mlforecast_loading);
                        lgbSeries.current.setData([]);
                        
                        dispatch( {type: FETCH_MLFORECAST_RESET_SECOND, payload: {}});
                }
                if ( (third_mlpData !== undefined) && (!chartUpdated || (third_mlforecast_loading === 2)) )
                {
                        console.log( 'THIRD_THIRD_THIRD_ updating MLForecast PREDICTIONS ' + symbolRef.current);
                        console.log(third_mlpData.get('LGBMRegressor'));

                        third_lgbSeries.current.setData(third_mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET_THIRD, payload: {}});
                } else if ( third_mlpData === undefined) {
                        console.log( 'THIRD_THIRD_THIRD_ 1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + third_mlforecast_loading);
                        third_lgbSeries.current.setData([]);
                        
                        dispatch( {type: FETCH_MLFORECAST_RESET_THIRD, payload: {}});
                }
                if ( (fifth_mlpData !== undefined) && (!chartUpdated || (fifth_mlforecast_loading === 2)) )
                {
                        console.log( 'FIFTH_FIFTH_FIFTH_ updating MLForecast PREDICTIONS ' + symbolRef.current);
                        console.log(fifth_mlpData.get('LGBMRegressor'));

                        fifth_lgbSeries.current.setData(fifth_mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                } else if ( fifth_mlpData === undefined) {
                        console.log( 'FIFTH_FIFTH_FIFTH_ 1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + fifth_mlforecast_loading);
                        fifth_lgbSeries.current.setData([]);
                        
                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                }
                if ( (first_mlpData !== undefined) && (!chartUpdated || (first_mlforecast_loading === 2)) )
                {
                        console.log( 'FIRST_FIRST_FIRST_ updating MLForecast PREDICTIONS ' + symbolRef.current);
                        console.log(first_mlpData.get('LGBMRegressor'));

                        first_lgbSeries.current.setData(first_mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                } else if ( first_mlpData === undefined) {
                        console.log( 'FIRST_FIRST_FIRST_ 1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + first_mlforecast_loading);
                        first_lgbSeries.current.setData([]);
                        
                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                }

            // TMD console.log(lwData);
            let pData = lwData[lwData.length-1];
            let mData = lwMACD[lwMACD.length-1];
            if ( !chartUpdated) 
            {
                if (lwData.length > 3)
                {
                    // TMD console.log( 'SAMEER -------------- SET_D  ' + coin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
                    series.current.setData(lwData);
                    if ( lwMACD.length > 5)
                    {
                        lineSeries.current.setData(lwMACD);
                        // TMD console.log( '------- setData(MACD) ----- ');
                        // TMD console.log( lwMACD);
                        if (mData !== undefined)
                        {
                            setPrevMacdTS(mData.time);
                        }
                    }
                        
                    setChartUpdated(true);
                    setPreviousTS(pData.time);
                } else {
                    // TMD console.log( 'SAMEER ------------UN_SET_D  ' + coin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
                }
            } else {
                if ( pData !== undefined)
                {
                    pData.close = ltp;
                    // TMD console.log(pData);
                    if (previousTS <= pData.time)
                    {
                        // TMD console.log( 'SAMEER -------------- UPDATE ' + coin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
                        series.current.update(pData);
                        setPreviousTS(pData.time);
                    }
                }
                if ( mData !== undefined)
                {
                    if ( prevMacdTS <= mData.time)
                    {
                        // TMD console.log( 'MACD   -------------- UPDATE ' + coin + ', ltp: ' + ltp + ', time: ' + mData.time + ', value: ' + mData.value);
                        // TMD console.log(mData);
                        lineSeries.current.update(mData);
                        setPrevMacdTS(mData.time);
                    }
                }
            }
            // TODO SAMEER NOT YET series.current.setData(lwData);

              let markers = [];
              if (markers_positive.length > 0)
              markers_positive.map((timestamp) => {
                // TMD console.log( 'SWL_POSITIVE MARKER ' + timestamp);
                      markers.push({
                        time: timestamp,
                        size: 2.4,
                        shape: "circle",
                        position: "inBar",
                        color: "lightgreen",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 2.2,
                        shape: "circle",
                        position: "inBar",
                        color: "black",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 1.4,
                        shape: "circle",
                        position: "inBar",
                        color: 'lightgreen',
                        text: "",
                      });
              });
              if (markers_negative.length > 0)
              markers_negative.map((timestamp) => {
                // TMD console.log( 'SWL_NEGATIVE MARKER ' + timestamp);
                      markers.push({
                        time: timestamp,
                        size: 2.4,
                        shape: "circle",
                        position: "inBar",
                        color: "red",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 2.2,
                        shape: "circle",
                        position: "inBar",
                        color: "black",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 1.4,
                        shape: "circle",
                        position: "inBar",
                        color: 'red',
                        text: "",
                      });
              });
             // TMD  console.log(markers);
             if ( markers.length > 0)
              series.current.setMarkers(markers);
        } else {
            // TMD console.log( 'SAMEER --NO_OP NO_OP  NO_OP  ' + coin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
        }
        /*
        if ( avg_px !== 0)
        {
            avgLine.current.applyOptions({
                price: avg_px,
            });
        }
        */


    }

  }, [ltp, ohlc_done_second, mlforecast_loading, third_mlforecast_loading, fifth_mlforecast_loading, first_mlforecast_loading, lineSeries]);

  return (
          <div class={classes.chart} onClick={handleClick} ref={chartContainerRef} />
  );
};
export default React.memo(LightweightSecondChart);
